import { render, staticRenderFns } from "./LoginWithMicrosoft.vue?vue&type=template&id=9e9a722a&scoped=true&"
import script from "./LoginWithMicrosoft.vue?vue&type=script&lang=js&"
export * from "./LoginWithMicrosoft.vue?vue&type=script&lang=js&"
import style0 from "./LoginWithMicrosoft.vue?vue&type=style&index=0&id=9e9a722a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9e9a722a",
  null
  
)

export default component.exports